import styled from "styled-components";
import {VerticalFlexStyle, baseDistance, fontSize, fontWeight, radius} from "../styles/styles";
import {colorPalette} from "../styles/colorPalette";

export const FilterEditorStyled = styled.div`
	${VerticalFlexStyle};
	height: inherit;

	.top-section {
		overflow-anchor: none;
		height: 100%;

		.SimpleFilterEditor {
			display: flex;
			flex-direction: column;
			border-top: none;
			max-height: calc(100vh - 333px);
			overflow-y: auto;

			.ToggleContainer {
				&:not(.FieldSection) {
					border-top: none;
					padding: 0;
					padding-left: ${baseDistance.xs};
				}

				&.open {
					background: ${colorPalette.gray.c100}; // used in default filter panel
					border-radius: ${radius.sm}; // used in default filter panel
				}

				.filter-title {
					font-weight: ${fontWeight.semiBold};
					font-size: ${fontSize.md};
					line-height: 16px;
					gap: ${baseDistance.xs};
					text-transform: none;
					color: ${colorPalette.gray.c950};
					height: 32px; // used in default filter panel

					svg {
						width: 16px;
						height: 16px;
						position: relative;
						padding: 0px !important;
					}

					.FilterTitle {
						&.applied {
							color: ${colorPalette.primary.c500Primary};
							display: flex;
							gap: ${baseDistance.xs};
							padding-left: 2px;

							span.close {
								svg.icon {
									width: 16px;
									height: 10px;
									fill: ${colorPalette.primary.c500Primary};
								}
							}
						}
					}
				}

				.children {
					// used in default filter panel
					&.open {
						padding: 0 ${baseDistance.sm};
					}
				}
			}
		}

		.separator {
			width: 100%;
			margin: ${baseDistance.md} 0px;
			border: 1px solid ${colorPalette.gray.c300};
		}

		.heading {
			flex-direction: column;
			margin-bottom: ${baseDistance.sm};

			.SearchField {
				width: 100%;
				margin: ${baseDistance.sm} 0px; // used in default filter panel
			}

			.FilterSwitch {
				display: flex;
				justify-content: end;
				padding-top: ${baseDistance.sm};
			}
		}
	}

	.bottom-buttons {
		display: flex;
		justify-content: end;
		gap: 10px;
		padding: ${baseDistance.md} 0;
	}
`;
